var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Ds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004d40",
    d: "M19.532 17.313L41 24 19.532 9.756z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#26a69a",
    d: "M30.316 4L11.618 4 7 12 21 12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00897b",
    d: "M41 24L30.316 4 21 12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#004d40",
    d: "M19.825 38.066L41 24 19.825 29.628z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00897b",
    d: "M21 31.097L41 24 20.998 16.924 17.26 24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#26a69a",
    d: "M21 16.924L17.094 15.56 8.056 24 17.094 32.461 21 31.096zM21 36.021L7 36.021 11.618 44 30.316 44 21.014 36.012z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00796b",
    d: "M7 12L18.184 15.94 21 12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00897b",
    d: "M21.014 36.012L30.316 44 41 24z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00796b",
    d: "M21 36L18.269 32.051 7 36.021 21 36.021z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00695c",
    d: "M21 31.096L17.094 32.461 21 36zM21 12L17.094 15.56 21 16.924z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Ds);
export default __webpack_public_path__ + "static/media/3ds.e33ea6968cc5a721e8e5279140a77d4c.svg";
export { ForwardRef as ReactComponent };